export enum Currency {
  USD = "USD",
  GBP = "GBP",
  EUR = "EUR",
  CAD = "CAD",
}

export const currencyOptions = [
  {
    label: "USD",
    value: Currency.USD,
  },
  {
    label: "GBP",
    value: Currency.GBP,
  },
  {
    label: "EUR",
    value: Currency.EUR,
  },
  {
    label: "CAD",
    value: Currency.CAD,
  },
];
